export const labelOf = <T extends string>(
  enumMap: Record<T, { label: string } | undefined>,
  value: T | undefined | null,
) => enumMap[value]?.label ?? value ?? "-"
